/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import type { Messages } from '@zcode/state-type'
import { combineReducers } from 'redux'
import type { ActionTypes } from '../types'
import { propertyDetails } from './propertyDetailsReducer'
import { streamConversations } from './streamConversations'
import { streamToken } from './streamTokenReducer'
import { streamUnreadCounts } from './streamUnreadCountsReducer'

export const messagesReducer = combineReducers<Messages, ActionTypes>({
  propertyDetails,
  streamConversations,
  streamToken,
  streamUnreadCounts,
})
